module.exports = __webpack_public_path__ + "media/images/icons/link-17b2e40b83f61b17cbc03e7647f2aa11.svg";